import { makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { useRetrospectiva } from "../context/RetrospectivaContext"
import { ContainerInsta } from "./ContainerInsta"
import { auroraSvg } from "./Svg"

const useStyles = makeStyles(() => ({
    container: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    titulo: {
        fontSize: 25,
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,.5)",
        marginBottom: 6,
    },
    list: {
        display: "grid",
        gridTemplateColumns: "1fr",
        rowGap: 16,
    },
    item: {
        display: "grid",
        gridTemplateColumns: "56px 64px 1fr",
        alignItems: "center",
        columnGap: 12,
        padding: "10px 12px",
        borderRadius: 12,
        background: "rgba(0,0,0,0.3)",
    },
    rank: {
        fontSize: "45px",
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,0.5)",
        marginBottom: 6,
    },
    thumbWrapper: {
        width: 64,
        height: 64,
        borderRadius: 8,
        background: "#ddd",
        overflow: "hidden",
    },
    thumb: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
    },
    nome: {
        width: "150px",
        fontSize: 18,
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,0.5)",
        marginBottom: 6,
        lineHeight: 1.15,

        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    sub: { fontSize: 12, color: "white", marginTop: 4 },
}))

export function ProdutosMaisVendidos() {
    const classes = useStyles()
    const dadosRestrospectiva = useRetrospectiva()
    const produtos = dadosRestrospectiva?.topProdutos
    const gradAmarelo = "linear-gradient(180deg, #ffe600 0%, #ffd400 55%, #ffb900 100%)"

    return (
        <ContainerInsta img={auroraSvg} gradiente={gradAmarelo}>
            <div className={classes.container}>
                <Typography className={classes.titulo}>Top 5 Produtos</Typography>

                <div className={classes.list}>
                    {produtos?.map((p, idx) => (
                        <div className={classes.item} key={idx}>
                            <div className={classes.rank}>{idx + 1}º</div>
                            <div className={classes.thumbWrapper}>
                                {p.urlImagem ? (
                                    <img className={classes.thumb} src={p.urlImagem} alt={p.nome} />
                                ) : null}
                            </div>
                            <div>
                                <div className={classes.nome}>{p.nome}</div>
                                {p?.qtdVendido && (
                                    <div className={classes.sub}>
                                        Quantidade vendidos: {p.qtdVendido}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </ContainerInsta>
    )
}
